import React, { Suspense } from 'react';

function universal(load, fallback = <span />) {
  const Cmp = React.lazy(load);
  return (props) => (
    <Suspense fallback={fallback}>
      <Cmp {...props} />
    </Suspense>
  );
}

export { default as AvatarImage } from './AvatarImage';
export const CtaButton = universal(() => import('./CtaButton'));
export const BonusStakes = universal(() => import('./BonusStakes'));
export const DailyBurnModal = universal(() => import('./DailyBurnModal'));
export const Description = universal(() => import('./Description'));
export const DynamicStat = universal(() => import('./DynamicStat'));
export const ExitIntent = universal(() => import('./ExitIntent'));
export const ExitModal = universal(() => import('./ExitModal'));
export const Link = universal(() => import('./Link'));
export const ListSignup = universal(() => import('./ListSignup'));
export const Markdown = universal(() => import('./Markdown'));
export const Modal = universal(() => import('./Modal'));
export const Stat = universal(() => import('./Stat'));
export const AccordionItem = universal(() => import('./AccordionItem'));
export const FormatRelative = universal(() => import('./FormatRelative'));
export const UpcomingGameButton = universal(() =>
  import('./UpcomingGameButton')
);
export const TransformerGoalCalculator = universal(() =>
  import('./TransformerGoalCalculator')
);
